import "./usecases.css";
import { TbWorldWww } from "react-icons/tb";
import { MdEmail } from "react-icons/md";
import { FaWifi } from "react-icons/fa";
import { FaMoneyCheckDollar } from "react-icons/fa6";
import { FaVideo } from "react-icons/fa";
import { FaPhone } from "react-icons/fa";
import { IoShareSocialSharp } from "react-icons/io5";
import { IoIosAddCircle } from "react-icons/io";
import { FaPersonDotsFromLine } from "react-icons/fa6";

const Usecases = () => {
  return (
    <div className="usecases">
      <div className="usecases__container">
        <h2 className="usecases__container__heading home-headers">Use Cases</h2>
        <div className="usecases__container__cards">
          <div className="usecases__container__cards__card">
            <TbWorldWww className="usecases__container__card__icon" />
            <h4 className="usecases__container__card__heading">URL</h4>
            <p>You can redirect users to a URL after they scan your QR Code.</p>
          </div>
          <div className="usecases__container__cards__card">
            <MdEmail className="usecases__container__card__icon" />
            <h4 className="usecases__container__card__heading">Email</h4>
            <p>
              You can send users to an email form with a predefined message.
            </p>
          </div>
          <div className="usecases__container__cards__card">
            <FaWifi className="usecases__container__card__icon" />
            <h4 className="usecases__container__card__heading">WiFi</h4>
            <p>
              You can allow users to connect to a WiFi network without a
              password.
            </p>
          </div>
          <div className="usecases__container__cards__card">
            <FaMoneyCheckDollar className="usecases__container__card__icon" />
            <h4 className="usecases__container__card__heading">Payments</h4>
            <p>
              You can allow users to send you payments by scanning your QR Code.
            </p>
          </div>
          <div className="usecases__container__cards__card">
            <FaVideo className="usecases__container__card__icon" />
            <h4 className="usecases__container__card__heading">Video</h4>
            <p>
              You can redirect users to a video after they scan your QR Code.
            </p>
          </div>
          <div className="usecases__container__cards__card">
            <FaPhone className="usecases__container__card__icon" />
            <h4 className="usecases__container__card__heading">Call</h4>
            <p>
              You can allows users to call you or a predefined number with your
              QR code.
            </p>
          </div>
          <div className="usecases__container__cards__card">
            <IoShareSocialSharp className="usecases__container__card__icon" />
            <h4 className="usecases__container__card__heading">Social Media</h4>
            <p>
              You can redirect users to a social media page after they scan your
              QR Code.
            </p>
          </div>
          <div className="usecases__container__cards__card">
            <IoIosAddCircle className="usecases__container__card__icon" />
            <h4 className="usecases__container__card__heading">And More!</h4>
            <p>
              We have many more use cases, sign up for free and checkout out our
              many options.
            </p>
          </div>
        </div>
        <button className="home-cta-btn">Get Started for Free</button>
      </div>
    </div>
  );
};

export default Usecases;
